import { useNavigate } from 'react-router-dom';

import { Result } from 'antd';

import { Button } from '@/shared/ui/Button';

export const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f0f2f5',
      }}>
      <Result
        status="403"
        title="403"
        subTitle="죄송합니다. 이 페이지에 접근할 권한이 없습니다."
        extra={
          <Button variant="filled" color="standard" onClick={() => navigate('/')}>
            홈으로 돌아가기
          </Button>
        }
      />
    </div>
  );
};
